export class Rpo {
    public id: string;
    public release: string;
    public releaseId: string;
    public version: string;
    public idioma: string;
    public localizacao: string;
    public localeId: string;
    public link_rpo: string;
    public published: boolean;
}
